<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>约课管理</Breadcrumb-item>
        <Breadcrumb-item>已结束课表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6" >
            <Form-item label="上课时间">
              <Row>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                    @on-change="startTimeDateChange"
                    :value="queryParam.startTimeDate"></Date-picker>
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                    @on-change="endTimeDateChange"
                               :value="queryParam.endTimeDate"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导" >
                <Input placeholder="支持模糊搜索" name="studyAdviserNickname"
                  v-model="queryParam.studyAdviserNickname"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程顾问昵称">
                <Input placeholder="支持模糊搜索" name="adviserNickname"
                  v-model="queryParam.adviserNickname"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师类型">
              <Select v-model.number="queryParam.tchCategory" placeholder="全部"
                @on-change="search" clearable>
                <Option v-for="item in $constant.teacherCategory"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程类型">
              <Select v-model.number="queryParam.lsnType" placeholder="全部"
                @on-change="search" clearable>
                <Option v-for="item in $constant.bookLessonOpenedLsnType"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="状态" >
              <Select v-model.number="queryParam.lsnSelStatus" placeholder="全部"
                @on-change="search" clearable>
                <Option v-for="item in $constant.lsnSelStatus"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程类别">
              <Select v-model.number="queryParam.courseType" placeholder="全部"
                @on-change="search" clearable>
                <Option v-for="item in $constant.courseType"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生ID" >
                <Input name="uid" v-model="queryParam.uid"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生手机号">
                <Input placeholder="支持模糊搜索" name="userMobile"
                  v-model="queryParam.userMobile"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生昵称" >
                <Input placeholder="支持模糊搜索" name="userNickname"
                  v-model="queryParam.userNickname"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="分配外教运营">
              <Select v-model.number="queryParam.tchStudyAdviserId" placeholder="全部"
                @on-change="search" clearable>
                <Option v-for="item in tchStudyAdviserList"
                  :value="item.id" :key="item.id">{{ item.nickname }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师ID" >
                <Input name="tchId" v-model="queryParam.tchId"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师姓名">
                <Input placeholder="支持模糊搜索" name="tchName"
                  v-model="queryParam.tchName"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师邮箱" >
                <Input placeholder="支持模糊搜索" name="tchEmail"
                  v-model="queryParam.tchEmail"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="评论时效" >
              <Select v-model.number="queryParam.reviewState" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">正常评价</Option>
                <Option value="2">超时评价</Option>
                <Option value="3">超时未评价</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="审核状态">
              <Select v-model.number="queryParam.checkStatus" placeholder="全部"
                @on-change="search" clearable>
                <Option v-for="item in $constant.bookLessonOpenedCheckStatus"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生是否投诉">
              <Select v-model="queryParam.userIsComplaint" placeholder="全部"
                @on-change="search" clearable>
                <Option value="1">是</Option>
                <Option value="2">否</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师是否评价">
              <Select v-model="queryParam.tchIsFeedback" placeholder="全部"
                @on-change="search" clearable>
                <Option value="1">是</Option>
                <Option value="0">否</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="是否单元报告">
              <Select v-model="queryParam.stageSummary" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">是</Option>
                <Option value="0">否</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="是否是第 10 课">
              <Select v-model="queryParam.isTenthLesson" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">是</Option>
                <Option value="0">否</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
              @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookLesson/finished/list"
      :params="queryParam" :onLoading="onLoading" class="finished-list"></List>
    <BalanceModal :openedId="openedId"  :successCallback="search" v-model="showBalanceModal"></BalanceModal>
    <RejectBalanceModal :openedId="openedId"  :successCallback="search" v-model="showRejectBalanceModal"></RejectBalanceModal>

    <BookUserFeedbackModal :openedId="openedId" v-model="showBookUserFeedbackModal" @on-close="onBookUserFeedBackClose"></BookUserFeedbackModal>
    <BookTchFeedbackModal :openedId="openedId" v-model="showBookTchFeedbackModal" @on-close="onBookTchFeedBackClose"></BookTchFeedbackModal>
    <BookTchScoreFeedbackModal :openedId="openedId" v-model="showBookTchScoreFeedbackModal" @on-close="onBookTchScoreFeedBackClose"></BookTchScoreFeedbackModal>
    <ClassMemberTimeModal :openedId="openedId" v-model="showClassMemberTimeModal" @on-close="onClassMemberClose"></ClassMemberTimeModal>
    <StudentWriteReviewDemoModal :openedId="openedId" :reviewState="reviewState" :value="studentWriteReviewDemoModal" :formData="studentWriteReviewDemoModalFormData" @on-close="closeReviewModal"></StudentWriteReviewDemoModal>
    <StudentWriteReviewRegularModal :openedId="openedId" :reviewState="reviewState" :value="studentWriteReviewRegularModal" :formData="studentWriteReviewRegularModalFormData" @on-close="closeReviewModal"></StudentWriteReviewRegularModal>
    <StudentWriteReviewFinishLevelModal :openedId="openedId" :reviewState="reviewState" :value="studentWriteReviewFinishLevelModal" :formData="studentWriteReviewFinishLevelModalFormData" @on-close="closeReviewModal"></StudentWriteReviewFinishLevelModal>
    <MonitorLessonRecordListModal :openedId="openedId"
      v-model="showMonitorLessonRecordListModal"></MonitorLessonRecordListModal>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId" :successCallback="search"></tch-info-modal>
  </div>
</template>
<style>
  .ivu-table .ivu-rate {
    font-size: 16px;
  }
  .ivu-table .ivu-rate-star {
    margin-left: 1px;
    margin-right: 1px;
  }
  .finished-list .ivu-table-cell {
    padding-left: 8px;
    padding-right: 8px;
  }
</style>
<script>
  import BalanceModal from './BalanceModal.vue'
  import RejectBalanceModal from './RejectBalanceModal.vue'
  import BookUserFeedbackModal from './BookUserFeedbackModal.vue'
  import BookTchFeedbackModal from './BookTchFeedbackModal.vue'
  import BookTchScoreFeedbackModal from './BookTchScoreFeedbackModal.vue'
  import ClassMemberTimeModal from './ClassMemberTimeModal.vue'
  import MonitorLessonRecordListModal from './modal/MonitorLessonRecordListModal.vue'
  import UserInfoModal from '../crm/UserInfoModal.vue'
  import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
  import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  import StudentWriteReviewDemoModal from '../user/StudentWriteReviewDemoModal.vue'
  import StudentWriteReviewRegularModal from '../user/StudentWriteReviewRegularModal.vue'
  import StudentWriteReviewFinishLevelModal from '../user/StudentWriteReviewFinishLevelModal.vue'
  export default {
    components: {
      BalanceModal,
      RejectBalanceModal,
      BookUserFeedbackModal,
      BookTchFeedbackModal,
      ClassMemberTimeModal,
      BookTchScoreFeedbackModal,
      MonitorLessonRecordListModal,
      UserInfoModal,
      TchInfoModal,
      StudentWriteReviewDemoModal,
      StudentWriteReviewRegularModal,
      StudentWriteReviewFinishLevelModal
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        studentWriteReviewRegularModalFormData: {
          rate1: 2,
          rate2: 2,
          rate3: 2,
          rate4: 2,
          word1: [
            {remark: ''}, {remark: ''}, {remark: ''}
          ],
          word2: [
            {remark: ''}, {remark: ''}, {remark: ''}
          ],
          word3: [
            {remark: ''}, {remark: ''}, {remark: ''}
          ],
          word4: [
            {remark: ''}, {remark: ''}, {remark: ''}
          ],
          fileList: [],
          parent: '',
          levelMsg: '',
        },
        studentWriteReviewDemoModalFormData: {
          remark: '',
          word1: '',
          word2: ''
        },
        studentWriteReviewFinishLevelModalFormData: {
          remark: '',
          suggestions: '',
          fileList: []
        },
        studentWriteReviewFinishLevelModal: false,
        studentWriteReviewRegularModal: false,
        studentWriteReviewDemoModal: false,
        searchLoading: false,
        rankScoreSeq: 0,
        editUser: false,
        uid: null,
        reload: 0,
        showTchInfoModal: false,
        tchId: null,
        queryParam: {
          tchId: '',
          tchName: '',
          tchEmail: '',
          uid: '',
          userMobile: '',
          userNickname: '',
          adviserNickname: '',
          studyAdviserNickname: '',
          tchCategory: '',
          lsnSelStatus: '',
          lsnType: '',
          courseType: '',
          checkStatus: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          reviewState: '',
          stageSummary: '',
          isTenthLesson: '',
          tchIsFeedback: '',
          userIsComplaint: ''
        },
        openedId: null,
        showBalanceModal: false,
        showRejectBalanceModal: false,
        showBookUserFeedbackModal: false,
        showClassMemberTimeModal: false,
        showBookTchFeedbackModal: false,
        showBookTchScoreFeedbackModal: false,
        showMonitorLessonRecordListModal: false,
        monitorLessonRecordId: null,
        tchStudyAdviserList: [],
        title: [
          {
            title: '学生ID、姓名',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.userNickname)
            }
          },
          {
            title: '老师姓名',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.tchFirstName + row.tchLastName,
                score: row.monthRankScore,
                onClick: () => this.openTchInfoModal(row.tchId, row.tchClassin)
              })
            }
          },
          {
            title: '学导',
            width: 70,
            align: 'center',
            key: 'studyAdviserNickname'
          },
          {
            title: '课程名称',
            width: 110,
            align: 'center',
             align: 'center',
            key: 'lessonTitle'
          },
          {
            title: '课程类型',
            align: 'center',
            width: 110,
            align: 'center',
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程顾问',
            width: 110,
            align: 'center',
            key: 'adviserNickname'
          },
          {
            title: '外教运营',
            width: 110,
            align: 'center',
            key: 'tchAdviserNickname'
          },
          {
            title: '上课时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '上课时长',
            align: 'center',
            width: 110,
            key: 'courseTime'
          },
          {
            title: '状态',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '学生对老师评价',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let bookUserFeedbackId = row.bookUserFeedbackId
              let bookUserFeedbackStar = row.bookUserFeedbackStar
              if (bookUserFeedbackId) {
                return h('div', [
                  h('Rate', {
                    props: {
                      disabled: true,
                      count: bookUserFeedbackStar,
                      value: bookUserFeedbackStar
                    }
                  }),
                  h('br'),
                  h('a', {on: {
                    click: () => {
                      this.openedId = row.id
                      this.showBookUserFeedbackModal = true
                    }
                  }}, '查看')
                ])
              }
              return h('span', { style: { color: 'red' } }, '未评论')
            }
          },
          {
            title: '老师对学生评价',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let bookTchFeedbackUid = row.bookTchFeedbackUid
              if (bookTchFeedbackUid) {
                return h('a', {on: {
                  click: () => {
                    this.openedId = row.id
                    if (row.lsnType === 1) {
                      this.studentWriteReviewDemoModal = true  // 新版本demo课评价
                    } else if (row.lsnType === 2) {
                      if (row.stageSummary) {
                        this.studentWriteReviewFinishLevelModal = true // 新版本阶段课程完成
                      } else {
                        this.studentWriteReviewRegularModal = true // 新版本常规课程评价
                      }
                    }
                  }
                }}, '查看')
              }
              return h('span', { style: { color: 'red' } }, '未评论')
            }
          },
          {
            title: '上课情况',
            width: 110,
            align: 'center',
            render: (h, params) => {
              return h('a', {on: {
                click: () => {
                  this.openedId = params.row.id
                  this.showClassMemberTimeModal = true
                }
              }}, '查看')
            }
          },
          {
            title: '教室',
            width: 80,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let classType = row.classType
              let typeEnum = $constant.getEnum($constant.classType, classType)
              return h('div', [
                h('span', typeEnum && typeEnum.text),
                h('span', '-'),
                h('br'),
                h('span', row.courseId)
              ])
            }
          },
          {
            title: '监课记录',
            width: 110,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let isMonitorLessonRecord = row.isMonitorLessonRecord
              if (isMonitorLessonRecord) {
                return h('a', {on: {
                  click: () => {
                    this.openedId = row.id
                    this.showMonitorLessonRecordListModal = true
                  }
                }}, '查看')
              }
              return h('span', { style: { color: 'red' } }, '未记录')
            }
          },
          {
            title: '审核状态',
            width: 85,
            align: 'center',
            render: (h, params) => {
              let checkStatus = params.row.checkStatus
              let statusEnum = $constant.getEnum($constant.bookLessonOpenedCheckStatus, checkStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '审核备注',
            width: 120,
            align: 'center',
            key: 'checkReason'
          },
          {
            title: '最后操作人',
            width: 120,
            align: 'center',
            key: 'adminNickname'
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 90,
            render: (h, params) => {
              let id = params.row.id
              return h('div', [
                h('a', {on: { click: () => {
                  this.openedId = id
                  this.showBalanceModal = true
                } }}, '课程结算'),
                h('br', {class: 'divider'}),
                h('a', {on: { click: () => {
                  this.openedId = id
                  this.showRejectBalanceModal = true
                } }}, '拒绝结算')
              ])
            }
          }
        ]
      }
    },
    mounted: function () {
      let self = this
      let queryParam = this.queryParam
      queryParam.uid = this.$route.query.uid
      this.$http.post('/adminUser/listByCondition', {adminGroupId: 7}).then(function (res) {
        self.tchStudyAdviserList = res.data
      })
    },
    created: function () {

      let startTime = this.queryParam.startTime
      if (startTime !== '') {
        this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate()
      }
      if (startTime === '') {
        let momentDate = this.$moment().add(-3, 'M')
        momentDate.millisecond(0)
        momentDate.second(0)
        momentDate.minute(0)
        momentDate.hour(0)
        this.queryParam.startTimeDate = momentDate.toDate()
        this.queryParam.startTime = momentDate.format('X')
      }

    },
    methods: {
      openTchInfoModal (val, classIn) {
        this.tchId = val
        this.showTchInfoModal = true
      },
      onBookUserFeedBackClose () {
        this.showBookUserFeedbackModal = false
      },
      onBookTchScoreFeedBackClose () {
        this.showBookTchScoreFeedbackModal = false
      },
      onBookTchFeedBackClose () {
        this.showBookTchFeedbackModal = false
      },
      onClassMemberClose (val) {
        this.showClassMemberTimeModal = false
      },
      closeModal (val) {
        this.uid = null
        this.editUser = false
      },
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/lesson/BookLessonFinishedList'}})
        window.open(href, '_blank')
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      closeReviewModal (val) {
        this.studentWriteReviewRegularModal = false
        this.studentWriteReviewDemoModal = false
        this.studentWriteReviewFinishLevelModal = false
      },
    }
  }
</script>



// WEBPACK FOOTER //
// BookLessonFinishedList.vue?0ec0cdde